"use strict";
// tslint:disable
/**
 * lead
 * Capture and calculate financial informations for our partners
 *
 * The version of the OpenAPI document: 1.17.0-rc.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateNadaVehicleDataJDPowerApi = exports.UpdateNadaVehicleDataJDPowerApiFactory = exports.UpdateNadaVehicleDataJDPowerApiFp = exports.UpdateNadaVehicleDataJDPowerApiAxiosParamCreator = exports.UniversityApi = exports.UniversityApiFactory = exports.UniversityApiFp = exports.UniversityApiAxiosParamCreator = exports.NadaVehiclesApi = exports.NadaVehiclesApiFactory = exports.NadaVehiclesApiFp = exports.NadaVehiclesApiAxiosParamCreator = exports.LeadSurveyResultApi = exports.LeadSurveyResultApiFactory = exports.LeadSurveyResultApiFp = exports.LeadSurveyResultApiAxiosParamCreator = exports.LeadSummariesApi = exports.LeadSummariesApiFactory = exports.LeadSummariesApiFp = exports.LeadSummariesApiAxiosParamCreator = exports.LeadApi = exports.LeadApiFactory = exports.LeadApiFp = exports.LeadApiAxiosParamCreator = exports.DeduplicationConfigurationApi = exports.DeduplicationConfigurationApiFactory = exports.DeduplicationConfigurationApiFp = exports.DeduplicationConfigurationApiAxiosParamCreator = exports.ClientTagApi = exports.ClientTagApiFactory = exports.ClientTagApiFp = exports.ClientTagApiAxiosParamCreator = exports.TimestampField = exports.SurveyKey = exports.SubmittedFrom = exports.State = exports.SavingsCompoundingMethod = exports.RefinanceLoanType = exports.ProvidedCreditRating = exports.ProductType = exports.ProductSubType = exports.PersonalReferenceRelationType = exports.PackageType = exports.Order = exports.MortgageType = exports.MortgageRefinanceType = exports.MortgagePurchaseStatus = exports.MortgagePropertyType = exports.MortgagePropertyStatus = exports.MortgagePropertySearchStatus = exports.MortgageOccupancyType = exports.MorgageLoanType = exports.MorgageAdjustmentType = exports.MedicalExam = exports.LoanTermUnit = exports.LoanPurpose = exports.LeadSurveyResultSortBy = exports.LeadActionType = exports.LeadActionRejectReason = exports.IdType = exports.GraduateDegreeType = exports.Gender = exports.FederalInsuranceType = exports.EmploymentStatus = exports.EmploymentPayFrequency = exports.EducationLevel = exports.EarningItemType = exports.EarningContextType = exports.EarningBonusType = exports.EarningBonusName = exports.DeduplicationConfigurationSort = exports.CreditCardIntroOfferType = exports.CitizenshipStatus = exports.CarrierDecisionType = exports.CardType = exports.CardPurpose = exports.CardBenefits = exports.BestTimeToCall = exports.BankAccountType = exports.AprType = void 0;
var globalImportUrl = require("url");
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
var AprType;
(function (AprType) {
    AprType["Variable"] = "variable";
    AprType["Regular"] = "regular";
    AprType["Fixed"] = "fixed";
})(AprType = exports.AprType || (exports.AprType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BankAccountType;
(function (BankAccountType) {
    BankAccountType["Checking"] = "checking";
    BankAccountType["Savings"] = "savings";
    BankAccountType["Other"] = "other";
})(BankAccountType = exports.BankAccountType || (exports.BankAccountType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var BestTimeToCall;
(function (BestTimeToCall) {
    BestTimeToCall["Morning"] = "morning";
    BestTimeToCall["Afternoon"] = "afternoon";
    BestTimeToCall["Evening"] = "evening";
    BestTimeToCall["Night"] = "night";
})(BestTimeToCall = exports.BestTimeToCall || (exports.BestTimeToCall = {}));
/**
 * Benefits or benefit categories related to a credit card
 * @export
 * @enum {string}
 */
var CardBenefits;
(function (CardBenefits) {
    CardBenefits["NoForeignTransactionFees"] = "No Foreign Transaction Fees";
    CardBenefits["PurchaseProtection"] = "Purchase Protection";
    CardBenefits["ReturnProtection"] = "Return Protection";
    CardBenefits["PriceProtection"] = "Price Protection";
    CardBenefits["FraudProtection"] = "Fraud Protection";
    CardBenefits["ExtendedWarranty"] = "Extended Warranty";
    CardBenefits["TravelAccidentInsurance"] = "Travel Accident Insurance";
    CardBenefits["TripInterruptionInsurance"] = "Trip Interruption Insurance";
    CardBenefits["CarRentalInsurance"] = "Car Rental Insurance";
    CardBenefits["BaggageInsurance"] = "Baggage Insurance";
    CardBenefits["BaggageDelayInsurance"] = "Baggage Delay Insurance";
    CardBenefits["HotelBurglaryInsurance"] = "Hotel Burglary Insurance";
    CardBenefits["TravelEmergencyAssistance"] = "Travel & Emergency Assistance";
    CardBenefits["RoadsideAssistance"] = "Roadside Assistance";
    CardBenefits["ConciergeService"] = "Concierge Service";
    CardBenefits["LoungeAccess"] = "Lounge Access";
    CardBenefits["IdentityTheftAssistance"] = "Identity Theft Assistance";
    CardBenefits["InFlightSavings"] = "In-Flight Savings";
    CardBenefits["FreeCheckedBag"] = "Free Checked Bag";
    CardBenefits["PriorityBoarding"] = "Priority Boarding";
    CardBenefits["NoBlackoutDates"] = "No Blackout Dates";
    CardBenefits["FreeCompanionTicket"] = "Free Companion Ticket";
    CardBenefits["DiscountCompanionTicket"] = "Discount Companion Ticket";
    CardBenefits["GlobalEntryOrTSAPreCheck"] = "Global Entry or TSA PreCheck";
    CardBenefits["PrivateJetPerks"] = "Private Jet Perks";
    CardBenefits["LoungeAccessDiscount"] = "Lounge Access Discount";
    CardBenefits["_247CardholderSupport"] = "24/7 Cardholder Support";
    CardBenefits["AuthorizedUser"] = "Authorized User";
    CardBenefits["EntertainmentAccess"] = "Entertainment Access";
    CardBenefits["AirlineFeeCredit"] = "Airline Fee Credit";
    CardBenefits["LateFeePass"] = "Late Fee Pass";
    CardBenefits["CreditScoreReporting"] = "Credit Score Reporting";
    CardBenefits["NoFlightChangeFees"] = "No Flight Change Fees";
    CardBenefits["_247AccountMonitoring"] = "24/7 Account Monitoring";
    CardBenefits["AmexOffers"] = "Amex Offers";
    CardBenefits["VisaSignatureOffers"] = "Visa Signature Offers";
    CardBenefits["MasterCardOffers"] = "MasterCard Offers";
    CardBenefits["FreeHotelStay"] = "Free Hotel Stay";
    CardBenefits["ExtendedHotelStay"] = "Extended Hotel Stay";
    CardBenefits["DiningConcierge"] = "Dining Concierge";
    CardBenefits["_2LoungePasses"] = "2 Lounge Passes";
    CardBenefits["HiltonHonorsSilverMembership"] = "Hilton Honors Silver Membership";
    CardBenefits["HiltonHonorsGoldMembership"] = "Hilton Honors Gold Membership";
    CardBenefits["WorldOfHyattDiscoveristStatus"] = "World of Hyatt Discoverist Status";
    CardBenefits["SPGGoldMembership"] = "SPG Gold Membership";
    CardBenefits["MarriottRewardsSilverStatus"] = "Marriott Rewards Silver Status";
    CardBenefits["HertzPresidentsCircleEliteStatus"] = "Hertz Presidents Circle Elite Status";
    CardBenefits["_2FreeCheckedBags"] = "2 Free Checked Bags";
    CardBenefits["AutoDiscounts"] = "Auto Discounts";
    CardBenefits["InCirclePartnership"] = "InCircle Partnership";
    CardBenefits["ShopRunner"] = "ShopRunner";
    CardBenefits["WiFiAccess"] = "WiFi Access";
    CardBenefits["ShopSafe"] = "ShopSafe";
    CardBenefits["BoAPreferredRewards"] = "BoA Preferred Rewards";
    CardBenefits["MasterCardFuelRewardsNetwork"] = "MasterCard Fuel Rewards Network";
    CardBenefits["MissedEventTicketProtection"] = "Missed Event Ticket Protection";
    CardBenefits["AccountFreezing"] = "Account Freezing";
    CardBenefits["CellPhoneProtection"] = "Cell Phone Protection";
    CardBenefits["GPARewards"] = "GPA Rewards";
    CardBenefits["InFlightWiFiCredit"] = "In-Flight WiFi Credit";
    CardBenefits["CitiPrivatePass"] = "Citi Private Pass";
    CardBenefits["PricelessCities"] = "Priceless Cities";
    CardBenefits["TheHotelCollection"] = "The Hotel Collection";
    CardBenefits["ByInvitationOnly"] = "By Invitation Only";
    CardBenefits["LuxuryHotelCollection"] = "Luxury Hotel Collection";
    CardBenefits["ExpediaSilverStatus"] = "Expedia+ Silver Status";
    CardBenefits["ExpediaGoldStatus"] = "Expedia+ Gold Status";
    CardBenefits["_100AmericanAirlinesDiscount"] = "$100 American Airlines Discount";
    CardBenefits["DisneyParksPerksAndSavings"] = "Disney Parks Perks and Savings";
    CardBenefits["RitzCarltonGoldEliteStatus"] = "Ritz-Carlton Gold Elite Status";
    CardBenefits["RitzCarltonClubLevelUpgrade"] = "Ritz-Carlton Club Level Upgrade";
    CardBenefits["AnnualTravelCredit"] = "Annual Travel Credit";
    CardBenefits["IHGPlatinumEliteStatus"] = "IHG Platinum Elite Status";
    CardBenefits["QuickBooksConnect"] = "QuickBooks Connect";
    CardBenefits["ReceiptMatch"] = "ReceiptMatch";
    CardBenefits["EmployeeSpendingLimits"] = "Employee Spending Limits";
    CardBenefits["FXInternationalPayments"] = "FX International Payments";
    CardBenefits["NoPreSetSpendingLimit"] = "No Pre-Set Spending Limit";
    CardBenefits["PurchaseFinancing"] = "Purchase Financing";
    CardBenefits["AmexOpenSavings"] = "Amex Open Savings";
    CardBenefits["AmazonSpecialFinancing"] = "Amazon Special Financing";
    CardBenefits["_100RitzCarltonHotelCredit"] = "$100 Ritz-Carlton Hotel Credit";
    CardBenefits["BritishAirwaysCompanionTicket"] = "British Airways Companion Ticket";
    CardBenefits["MercedesBenzGiftCertificates"] = "Mercedes-Benz Gift Certificates";
    CardBenefits["MercedesBenzExcessMileageWaiver"] = "Mercedes-Benz Excess Mileage Waiver";
    CardBenefits["JetBlueAnnualStatementCredit"] = "JetBlue Annual Statement Credit";
    CardBenefits["_20DiscountOnDeltaFlightsForDeltaPrivateJetMembers"] = "20% Discount on Delta Flights for Delta Private Jet Members";
    CardBenefits["ExpenseReportFeatures"] = "Expense Report Features";
    CardBenefits["BusinessCellPhoneProtection"] = "Business Cell Phone Protection";
    CardBenefits["FreeShippingOnMostTargetComOrders"] = "Free Shipping on most Target.com orders";
    CardBenefits["_30ExtraDaysForReturns"] = "30 Extra Days for Returns";
    CardBenefits["FreeClothingAltertaions"] = "Free clothing altertaions";
    CardBenefits["PersonalShopping"] = "Personal shopping";
    CardBenefits["ShopmywaySavings"] = "Shopmyway Savings";
    CardBenefits["OnlineSubscriptionCredit"] = "Online Subscription Credit";
    CardBenefits["UberExclusiveAccess"] = "Uber Exclusive Access";
    CardBenefits["AirlineBenefits"] = "Airline Benefits";
    CardBenefits["HotelBenefits"] = "Hotel Benefits";
    CardBenefits["OtherTravelBenefits"] = "Other Travel Benefits";
    CardBenefits["EmergencyAssistance"] = "Emergency Assistance";
    CardBenefits["Experiences"] = "Experiences";
    CardBenefits["ShoppingBenefits"] = "Shopping Benefits";
    CardBenefits["CardholderBenefits"] = "Cardholder Benefits";
    CardBenefits["EnhancedSecurity"] = "Enhanced Security";
    CardBenefits["BusinessBenefits"] = "Business Benefits";
    CardBenefits["OtherBenefits"] = "Other Benefits";
    CardBenefits["InFlightDiscounts"] = "In-Flight Discounts";
    CardBenefits["FeeCoverage"] = "Fee Coverage";
    CardBenefits["FlightCreditsDiscounts"] = "Flight Credits & Discounts";
    CardBenefits["HotelMembershipStatus"] = "Hotel Membership Status";
    CardBenefits["HotelCreditFreeStays"] = "Hotel Credit & Free Stays";
    CardBenefits["TravelCredit"] = "Travel Credit";
    CardBenefits["TravelExperiencesPrograms"] = "Travel Experiences Programs";
    CardBenefits["CarRentalMembershipStatus"] = "Car Rental Membership Status";
    CardBenefits["ExtraGasRewards"] = "Extra Gas Rewards";
    CardBenefits["ShoppingProtection"] = "Shopping Protection";
    CardBenefits["ShoppingDiscounts"] = "Shopping Discounts";
    CardBenefits["FreeShipping"] = "Free Shipping";
    CardBenefits["TheBoingoAmericanExpressPreferredPlan"] = "The Boingo American Express Preferred Plan";
    CardBenefits["AirSpaceLounge"] = "AirSpace Lounge";
    CardBenefits["UberMonthlyCredit"] = "Uber Monthly Credit";
    CardBenefits["RideShareBenefits"] = "Ride Share Benefits";
    CardBenefits["DeltaSkyClub"] = "Delta Sky Club";
    CardBenefits["AdmiralsClubMembership"] = "Admirals Club Membership";
    CardBenefits["PriorityPassSelectMembershipPrestige"] = "Priority Pass Select Membership (Prestige)";
    CardBenefits["PriorityPassSelectMembershipStandardPlus"] = "Priority Pass Select Membership (Standard Plus)";
    CardBenefits["DailyBreakfast"] = "Daily Breakfast";
    CardBenefits["EarlyCheckInLateCheckOut"] = "Early Check-in & Late Check-out";
    CardBenefits["RoomUpgrades"] = "Room Upgrades";
    CardBenefits["ComplementaryWiFi"] = "Complementary WiFi";
    CardBenefits["AmexHotelCollectionCredit"] = "Amex Hotel Collection Credit";
    CardBenefits["TemporaryAccountNumbers"] = "Temporary Account Numbers";
    CardBenefits["OneTime50DiscountOnCompanionTicket"] = "One-Time 50% Discount on Companion Ticket";
    CardBenefits["AirlineTravelCredit"] = "Airline Travel Credit";
    CardBenefits["UnitedClubMembership"] = "United Club Membership";
    CardBenefits["ChipTechnology"] = "Chip Technology";
    CardBenefits["EarnMoreMilesForSharingTravelStories"] = "Earn More Miles for Sharing Travel Stories";
    CardBenefits["MastercardWorldEliteConciergeAndLuxuryTravelBenefits"] = "Mastercard World Elite Concierge and Luxury Travel Benefits";
    CardBenefits["_20SavingsOnDeltaInFlightPurchases"] = "20% Savings on Delta In-Flight Purchases";
    CardBenefits["_25SavingsOnUnitedInFlightFoodAndDrinkPurchases"] = "25% Savings on United In-Flight Food and Drink Purchases";
    CardBenefits["_100HiltonPropertiesCredit"] = "$100 Hilton Properties Credit";
    CardBenefits["_250HiltonResortCredit"] = "$250 Hilton Resort Credit";
    CardBenefits["HiltonHonorsDiamondMembership"] = "Hilton Honors Diamond Membership";
    CardBenefits["FreeBirthdayGift"] = "Free Birthday Gift";
    CardBenefits["_2xPointsDuringYourBirthdayMonth"] = "2x Points During Your Birthday Month";
    CardBenefits["CarRentalVIPPerks"] = "Car Rental VIP Perks";
    CardBenefits["FreeShippingWithThePurchaseOfABra"] = "Free shipping with the purchase of a bra";
    CardBenefits["MonthlyDiningCredit"] = "Monthly Dining Credit";
    CardBenefits["AmazonPrimeStudent"] = "Amazon Prime Student";
})(CardBenefits = exports.CardBenefits || (exports.CardBenefits = {}));
/**
 * Purposes or categories related to a credit card
 * @export
 * @enum {string}
 */
var CardPurpose;
(function (CardPurpose) {
    CardPurpose["BalanceTransfer"] = "balance_transfer";
    CardPurpose["CashBack"] = "cash_back";
    CardPurpose["EarningRewards"] = "earning_rewards";
    CardPurpose["ImproveCredit"] = "improve_credit";
    CardPurpose["LowInterest"] = "low_interest";
    CardPurpose["NewToCredit"] = "new_to_credit";
    CardPurpose["Student"] = "student";
    CardPurpose["TravelIncentives"] = "travel_incentives";
})(CardPurpose = exports.CardPurpose || (exports.CardPurpose = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CardType;
(function (CardType) {
    CardType["Visa"] = "visa";
    CardType["Mastercard"] = "mastercard";
    CardType["AmericanExpress"] = "american_express";
    CardType["Discover"] = "discover";
})(CardType = exports.CardType || (exports.CardType = {}));
/**
 * Carrier decision speed
 * @export
 * @enum {string}
 */
var CarrierDecisionType;
(function (CarrierDecisionType) {
    CarrierDecisionType["Instant"] = "instant";
    CarrierDecisionType["NonInstant"] = "non_instant";
})(CarrierDecisionType = exports.CarrierDecisionType || (exports.CarrierDecisionType = {}));
/**
 * Citizenship status
 * @export
 * @enum {string}
 */
var CitizenshipStatus;
(function (CitizenshipStatus) {
    CitizenshipStatus["Citizen"] = "citizen";
    CitizenshipStatus["PermanentResident"] = "permanent_resident";
    CitizenshipStatus["Other"] = "other";
})(CitizenshipStatus = exports.CitizenshipStatus || (exports.CitizenshipStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var CreditCardIntroOfferType;
(function (CreditCardIntroOfferType) {
    CreditCardIntroOfferType["Miles"] = "miles";
    CreditCardIntroOfferType["Points"] = "points";
    CreditCardIntroOfferType["StatementCredit"] = "statement_credit";
})(CreditCardIntroOfferType = exports.CreditCardIntroOfferType || (exports.CreditCardIntroOfferType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var DeduplicationConfigurationSort;
(function (DeduplicationConfigurationSort) {
    DeduplicationConfigurationSort["Id"] = "id";
    DeduplicationConfigurationSort["SupplySubAccountId"] = "supplySubAccountId";
    DeduplicationConfigurationSort["DurationMinutes"] = "durationMinutes";
    DeduplicationConfigurationSort["CreatedAt"] = "createdAt";
    DeduplicationConfigurationSort["DeletedAt"] = "deletedAt";
})(DeduplicationConfigurationSort = exports.DeduplicationConfigurationSort || (exports.DeduplicationConfigurationSort = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EarningBonusName;
(function (EarningBonusName) {
    EarningBonusName["SignUpBonus"] = "Sign-Up Bonus";
    EarningBonusName["AnniversaryBonus"] = "Anniversary Bonus";
    EarningBonusName["AnnualBonus"] = "Annual Bonus";
    EarningBonusName["UsageBonus"] = "Usage Bonus";
})(EarningBonusName = exports.EarningBonusName || (exports.EarningBonusName = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EarningBonusType;
(function (EarningBonusType) {
    EarningBonusType["OneTime"] = "One Time";
    EarningBonusType["Recurring"] = "Recurring";
})(EarningBonusType = exports.EarningBonusType || (exports.EarningBonusType = {}));
/**
 * The type of context this is. Basic contexts have no details.
 * @export
 * @enum {string}
 */
var EarningContextType;
(function (EarningContextType) {
    EarningContextType["Basic"] = "basic";
    EarningContextType["Calculation"] = "calculation";
    EarningContextType["Introductory"] = "introductory";
    EarningContextType["Rotating"] = "rotating";
    EarningContextType["Capped"] = "capped";
})(EarningContextType = exports.EarningContextType || (exports.EarningContextType = {}));
/**
 * Refers to the type (and schema) of the item
 * @export
 * @enum {string}
 */
var EarningItemType;
(function (EarningItemType) {
    EarningItemType["Category"] = "category";
    EarningItemType["Merchant"] = "merchant";
    EarningItemType["Ebp"] = "ebp";
    EarningItemType["PaymentMethod"] = "paymentMethod";
})(EarningItemType = exports.EarningItemType || (exports.EarningItemType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EducationLevel;
(function (EducationLevel) {
    EducationLevel["HighSchool"] = "high_school";
    EducationLevel["Associate"] = "associate";
    EducationLevel["Bachelors"] = "bachelors";
    EducationLevel["Masters"] = "masters";
    EducationLevel["Doctorate"] = "doctorate";
    EducationLevel["OtherGradDegree"] = "other_grad_degree";
    EducationLevel["Certificate"] = "certificate";
    EducationLevel["DidNotGraduate"] = "did_not_graduate";
    EducationLevel["StillEnrolled"] = "still_enrolled";
    EducationLevel["Other"] = "other";
})(EducationLevel = exports.EducationLevel || (exports.EducationLevel = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EmploymentPayFrequency;
(function (EmploymentPayFrequency) {
    EmploymentPayFrequency["Weekly"] = "weekly";
    EmploymentPayFrequency["Biweekly"] = "biweekly";
    EmploymentPayFrequency["TwiceMonthly"] = "twice_monthly";
    EmploymentPayFrequency["Monthly"] = "monthly";
})(EmploymentPayFrequency = exports.EmploymentPayFrequency || (exports.EmploymentPayFrequency = {}));
/**
 *
 * @export
 * @enum {string}
 */
var EmploymentStatus;
(function (EmploymentStatus) {
    EmploymentStatus["Employed"] = "employed";
    EmploymentStatus["EmployedFullTime"] = "employed_full_time";
    EmploymentStatus["EmployedPartTime"] = "employed_part_time";
    EmploymentStatus["Military"] = "military";
    EmploymentStatus["NotEmployed"] = "not_employed";
    EmploymentStatus["SelfEmployed"] = "self_employed";
    EmploymentStatus["Retired"] = "retired";
    EmploymentStatus["Other"] = "other";
})(EmploymentStatus = exports.EmploymentStatus || (exports.EmploymentStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var FederalInsuranceType;
(function (FederalInsuranceType) {
    FederalInsuranceType["Fdic"] = "fdic";
    FederalInsuranceType["Ncua"] = "ncua";
})(FederalInsuranceType = exports.FederalInsuranceType || (exports.FederalInsuranceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Gender;
(function (Gender) {
    Gender["Male"] = "male";
    Gender["Female"] = "female";
})(Gender = exports.Gender || (exports.Gender = {}));
/**
 *
 * @export
 * @enum {string}
 */
var GraduateDegreeType;
(function (GraduateDegreeType) {
    GraduateDegreeType["DoctorOfMedicine"] = "doctor_of_medicine";
    GraduateDegreeType["DoctorOfOsteopathicMedicine"] = "doctor_of_osteopathic_medicine";
    GraduateDegreeType["DoctorOfOptometry"] = "doctor_of_optometry";
    GraduateDegreeType["DoctorOfDentalMedicine"] = "doctor_of_dental_medicine";
    GraduateDegreeType["DentariaeMedicinaeDoctoris"] = "dentariae_medicinae_doctoris";
    GraduateDegreeType["DoctorOfDentalSurgery"] = "doctor_of_dental_surgery";
    GraduateDegreeType["DoctorOfVeterinaryMedicine"] = "doctor_of_veterinary_medicine";
    GraduateDegreeType["DoctorOfPharmacy"] = "doctor_of_pharmacy";
    GraduateDegreeType["VeterinariaeMedicinaeDoctoris"] = "veterinariae_medicinae_doctoris";
    GraduateDegreeType["MasterOfArts"] = "master_of_arts";
    GraduateDegreeType["MasterOfScience"] = "master_of_science";
    GraduateDegreeType["MasterOfResearch"] = "master_of_research";
    GraduateDegreeType["MasterOfResearchProject"] = "master_of_research_project";
    GraduateDegreeType["MasterOfStudies"] = "master_of_studies";
    GraduateDegreeType["MasterOfBusinessAdministration"] = "master_of_business_administration";
    GraduateDegreeType["MasterOfLibraryScience"] = "master_of_library_science";
    GraduateDegreeType["MasterOfPublicAdministration"] = "master_of_public_administration";
    GraduateDegreeType["MasterOfPublicHealth"] = "master_of_public_health";
    GraduateDegreeType["MasterOfLaws"] = "master_of_laws";
    GraduateDegreeType["MasterOfArtsLiberalStudies"] = "master_of_arts_liberal_studies";
    GraduateDegreeType["MasterOfFineArts"] = "master_of_fine_arts";
    GraduateDegreeType["MasterOfMusic"] = "master_of_music";
    GraduateDegreeType["MasterOfEducation"] = "master_of_education";
    GraduateDegreeType["MasterOfEngineering"] = "master_of_engineering";
    GraduateDegreeType["MasterOfArchitecture"] = "master_of_architecture";
    GraduateDegreeType["JurisDoctor"] = "juris_doctor";
    GraduateDegreeType["Other"] = "other";
})(GraduateDegreeType = exports.GraduateDegreeType || (exports.GraduateDegreeType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var IdType;
(function (IdType) {
    IdType["DriverLicense"] = "driver_license";
    IdType["StateId"] = "state_id";
    IdType["Passport"] = "passport";
})(IdType = exports.IdType || (exports.IdType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LeadActionRejectReason;
(function (LeadActionRejectReason) {
    LeadActionRejectReason["LowFico"] = "low_fico";
    LeadActionRejectReason["NoFico"] = "no_fico";
    LeadActionRejectReason["MajorDerogatory"] = "major_derogatory";
    LeadActionRejectReason["UnderwritingDecline"] = "underwriting_decline";
    LeadActionRejectReason["DebtToIncomeRatio"] = "debt_to_income_ratio";
    LeadActionRejectReason["NotInActiveState"] = "not_in_active_state";
    LeadActionRejectReason["IncorrectDataProvided"] = "incorrect_data_provided";
    LeadActionRejectReason["Duplicate"] = "duplicate";
})(LeadActionRejectReason = exports.LeadActionRejectReason || (exports.LeadActionRejectReason = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LeadActionType;
(function (LeadActionType) {
    LeadActionType["Initialized"] = "initialized";
    LeadActionType["ApiRejected"] = "api_rejected";
    LeadActionType["ApiApproved"] = "api_approved";
    LeadActionType["ApiListing"] = "api_listing";
    LeadActionType["ClickedReferralLink"] = "clicked_referral_link";
    LeadActionType["ClickedSpecialOfferLink"] = "clicked_special_offer_link";
    LeadActionType["SpecialOfferConversion"] = "special_offer_conversion";
    LeadActionType["Applied"] = "applied";
    LeadActionType["Rejected"] = "rejected";
    LeadActionType["Approved"] = "approved";
    LeadActionType["Listed"] = "listed";
    LeadActionType["Funded"] = "funded";
    LeadActionType["NotFunded"] = "not_funded";
    LeadActionType["ClickedCreditCardOfferLink"] = "clicked_credit_card_offer_link";
    LeadActionType["ClickedMortgageOfferLink"] = "clicked_mortgage_offer_link";
    LeadActionType["ClickedSavingsOfferLink"] = "clicked_savings_offer_link";
})(LeadActionType = exports.LeadActionType || (exports.LeadActionType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LeadSurveyResultSortBy;
(function (LeadSurveyResultSortBy) {
    LeadSurveyResultSortBy["Id"] = "id";
    LeadSurveyResultSortBy["SurveyKey"] = "surveyKey";
    LeadSurveyResultSortBy["Results"] = "results";
})(LeadSurveyResultSortBy = exports.LeadSurveyResultSortBy || (exports.LeadSurveyResultSortBy = {}));
/**
 *
 * @export
 * @enum {string}
 */
var LoanPurpose;
(function (LoanPurpose) {
    LoanPurpose["Auto"] = "auto";
    LoanPurpose["AutoPurchase"] = "auto_purchase";
    LoanPurpose["AutoRefinance"] = "auto_refinance";
    LoanPurpose["Baby"] = "baby";
    LoanPurpose["Boat"] = "boat";
    LoanPurpose["Business"] = "business";
    LoanPurpose["CarRepair"] = "car_repair";
    LoanPurpose["Cosmetic"] = "cosmetic";
    LoanPurpose["CreditCardRefi"] = "credit_card_refi";
    LoanPurpose["DebtConsolidation"] = "debt_consolidation";
    LoanPurpose["Emergency"] = "emergency";
    LoanPurpose["Engagement"] = "engagement";
    LoanPurpose["Green"] = "green";
    LoanPurpose["HomeImprovement"] = "home_improvement";
    LoanPurpose["HomePurchase"] = "home_purchase";
    LoanPurpose["HomeRefi"] = "home_refi";
    LoanPurpose["HouseholdExpenses"] = "household_expenses";
    LoanPurpose["LargePurchases"] = "large_purchases";
    LoanPurpose["LifeEvent"] = "life_event";
    LoanPurpose["MedicalDental"] = "medical_dental";
    LoanPurpose["Motorcycle"] = "motorcycle";
    LoanPurpose["MovingRelocation"] = "moving_relocation";
    LoanPurpose["Other"] = "other";
    LoanPurpose["Rv"] = "rv";
    LoanPurpose["SpecialOccasion"] = "special_occasion";
    LoanPurpose["StudentLoan"] = "student_loan";
    LoanPurpose["StudentLoanRefi"] = "student_loan_refi";
    LoanPurpose["Taxes"] = "taxes";
    LoanPurpose["Unknown"] = "unknown";
    LoanPurpose["Vacation"] = "vacation";
    LoanPurpose["Wedding"] = "wedding";
})(LoanPurpose = exports.LoanPurpose || (exports.LoanPurpose = {}));
/**
 * Unit of measure for offer term lengths, or open for a single term.
 * @export
 * @enum {string}
 */
var LoanTermUnit;
(function (LoanTermUnit) {
    LoanTermUnit["Day"] = "day";
    LoanTermUnit["Month"] = "month";
    LoanTermUnit["Year"] = "year";
    LoanTermUnit["Open"] = "open";
})(LoanTermUnit = exports.LoanTermUnit || (exports.LoanTermUnit = {}));
/**
 * Medical exam requirement
 * @export
 * @enum {string}
 */
var MedicalExam;
(function (MedicalExam) {
    MedicalExam["NoExamIfQualified"] = "no_exam_if_qualified";
    MedicalExam["NoExamGuaranteed"] = "no_exam_guaranteed";
    MedicalExam["ExamRequired"] = "exam_required";
})(MedicalExam = exports.MedicalExam || (exports.MedicalExam = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MorgageAdjustmentType;
(function (MorgageAdjustmentType) {
    MorgageAdjustmentType["Credits"] = "credits";
    MorgageAdjustmentType["Par"] = "par";
    MorgageAdjustmentType["Points"] = "points";
})(MorgageAdjustmentType = exports.MorgageAdjustmentType || (exports.MorgageAdjustmentType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MorgageLoanType;
(function (MorgageLoanType) {
    MorgageLoanType["FifteenYearFixed"] = "fifteen_year_fixed";
    MorgageLoanType["ThirtyYearFixed"] = "thirty_year_fixed";
    MorgageLoanType["FiveOneAdjustable"] = "five_one_adjustable";
    MorgageLoanType["SevenOneAdjustable"] = "seven_one_adjustable";
    MorgageLoanType["TenOneAdjustable"] = "ten_one_adjustable";
})(MorgageLoanType = exports.MorgageLoanType || (exports.MorgageLoanType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgageOccupancyType;
(function (MortgageOccupancyType) {
    MortgageOccupancyType["Primary"] = "primary";
    MortgageOccupancyType["Secondary"] = "secondary";
    MortgageOccupancyType["Investment"] = "investment";
})(MortgageOccupancyType = exports.MortgageOccupancyType || (exports.MortgageOccupancyType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgagePropertySearchStatus;
(function (MortgagePropertySearchStatus) {
    MortgagePropertySearchStatus["Found"] = "found";
    MortgagePropertySearchStatus["NotFound"] = "not_found";
})(MortgagePropertySearchStatus = exports.MortgagePropertySearchStatus || (exports.MortgagePropertySearchStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgagePropertyStatus;
(function (MortgagePropertyStatus) {
    MortgagePropertyStatus["OwnOutright"] = "own_outright";
    MortgagePropertyStatus["OwnWithMortgage"] = "own_with_mortgage";
    MortgagePropertyStatus["Rent"] = "rent";
})(MortgagePropertyStatus = exports.MortgagePropertyStatus || (exports.MortgagePropertyStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgagePropertyType;
(function (MortgagePropertyType) {
    MortgagePropertyType["Rent"] = "rent";
    MortgagePropertyType["Condo"] = "condo";
    MortgagePropertyType["MultiUnit"] = "multi_unit";
    MortgagePropertyType["SingleFamily"] = "single_family";
    MortgagePropertyType["Townhouse"] = "townhouse";
})(MortgagePropertyType = exports.MortgagePropertyType || (exports.MortgagePropertyType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgagePurchaseStatus;
(function (MortgagePurchaseStatus) {
    MortgagePurchaseStatus["NoOffer"] = "no_offer";
    MortgagePurchaseStatus["OfferAccepted"] = "offer_accepted";
    MortgagePurchaseStatus["OfferPending"] = "offer_pending";
    MortgagePurchaseStatus["UnderContract"] = "under_contract";
})(MortgagePurchaseStatus = exports.MortgagePurchaseStatus || (exports.MortgagePurchaseStatus = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgageRefinanceType;
(function (MortgageRefinanceType) {
    MortgageRefinanceType["CashOut"] = "cash_out";
    MortgageRefinanceType["RateTerm"] = "rate_term";
})(MortgageRefinanceType = exports.MortgageRefinanceType || (exports.MortgageRefinanceType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var MortgageType;
(function (MortgageType) {
    MortgageType["Purchase"] = "purchase";
    MortgageType["Refinance"] = "refinance";
})(MortgageType = exports.MortgageType || (exports.MortgageType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var Order;
(function (Order) {
    Order["Asc"] = "asc";
    Order["Desc"] = "desc";
})(Order = exports.Order || (exports.Order = {}));
/**
 * Life insurance package types
 * @export
 * @enum {string}
 */
var PackageType;
(function (PackageType) {
    PackageType["Basic"] = "basic";
    PackageType["Essential"] = "essential";
    PackageType["Elite"] = "elite";
})(PackageType = exports.PackageType || (exports.PackageType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var PersonalReferenceRelationType;
(function (PersonalReferenceRelationType) {
    PersonalReferenceRelationType["Parent"] = "parent";
    PersonalReferenceRelationType["Employer"] = "employer";
    PersonalReferenceRelationType["Spouse"] = "spouse";
    PersonalReferenceRelationType["Guardian"] = "guardian";
    PersonalReferenceRelationType["Sibling"] = "sibling";
    PersonalReferenceRelationType["Relative"] = "relative";
    PersonalReferenceRelationType["Friend"] = "friend";
    PersonalReferenceRelationType["Other"] = "other";
})(PersonalReferenceRelationType = exports.PersonalReferenceRelationType || (exports.PersonalReferenceRelationType = {}));
/**
 * A type of financial product
 * @export
 * @enum {string}
 */
var ProductSubType;
(function (ProductSubType) {
    ProductSubType["CreditCard"] = "credit_card";
    ProductSubType["SecuredCard"] = "secured_card";
    ProductSubType["PersonalLoan"] = "personal_loan";
    ProductSubType["SecuredLoan"] = "secured_loan";
    ProductSubType["StudentLoanRefinance"] = "student_loan_refinance";
    ProductSubType["CoApplicantLoan"] = "co_applicant_loan";
    ProductSubType["LineOfCredit"] = "line_of_credit";
    ProductSubType["AutomobileRefinance"] = "automobile_refinance";
    ProductSubType["HomeEquityLineOfCredit"] = "home_equity_line_of_credit";
    ProductSubType["Purchase"] = "purchase";
    ProductSubType["Refinance"] = "refinance";
    ProductSubType["SavingsAccount"] = "savings_account";
    ProductSubType["MoneyMarketAccount"] = "money_market_account";
    ProductSubType["CertificateOfDeposit"] = "certificate_of_deposit";
    ProductSubType["IndividualRetirementAccount"] = "individual_retirement_account";
    ProductSubType["CashManagementAccount"] = "cash_management_account";
    ProductSubType["HighInterestChecking"] = "high_interest_checking";
    ProductSubType["AccidentalDeathBenefits"] = "accidental_death_benefits";
    ProductSubType["TermLife"] = "term_life";
    ProductSubType["TermLifeInstant"] = "term_life_instant";
    ProductSubType["WholeLife"] = "whole_life";
    ProductSubType["DebtRelief"] = "debt_relief";
    ProductSubType["InstallmentLoans"] = "installment_loans";
    ProductSubType["CreditBuilder"] = "credit_builder";
    ProductSubType["CashAdvance"] = "cash_advance";
    ProductSubType["CreditRepair"] = "credit_repair";
})(ProductSubType = exports.ProductSubType || (exports.ProductSubType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProductType;
(function (ProductType) {
    ProductType["CreditCard"] = "credit_card";
    ProductType["Insurance"] = "insurance";
    ProductType["LifeInsurance"] = "life_insurance";
    ProductType["Loan"] = "loan";
    ProductType["Mortgage"] = "mortgage";
    ProductType["Savings"] = "savings";
    ProductType["Other"] = "other";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var ProvidedCreditRating;
(function (ProvidedCreditRating) {
    ProvidedCreditRating["Excellent"] = "excellent";
    ProvidedCreditRating["Good"] = "good";
    ProvidedCreditRating["Fair"] = "fair";
    ProvidedCreditRating["Poor"] = "poor";
    ProvidedCreditRating["Limited"] = "limited";
    ProvidedCreditRating["Unknown"] = "unknown";
})(ProvidedCreditRating = exports.ProvidedCreditRating || (exports.ProvidedCreditRating = {}));
/**
 *
 * @export
 * @enum {string}
 */
var RefinanceLoanType;
(function (RefinanceLoanType) {
    RefinanceLoanType["FederalStudentLoan"] = "federal_student_loan";
    RefinanceLoanType["PrivateStudentLoan"] = "private_student_loan";
})(RefinanceLoanType = exports.RefinanceLoanType || (exports.RefinanceLoanType = {}));
/**
 *
 * @export
 * @enum {string}
 */
var SavingsCompoundingMethod;
(function (SavingsCompoundingMethod) {
    SavingsCompoundingMethod["Annually"] = "annually";
    SavingsCompoundingMethod["Continuous"] = "continuous";
    SavingsCompoundingMethod["Daily"] = "daily";
    SavingsCompoundingMethod["Monthly"] = "monthly";
    SavingsCompoundingMethod["Quarterly"] = "quarterly";
    SavingsCompoundingMethod["SemiAnnually"] = "semiAnnually";
    SavingsCompoundingMethod["Simple"] = "simple";
    SavingsCompoundingMethod["Weekly"] = "weekly";
})(SavingsCompoundingMethod = exports.SavingsCompoundingMethod || (exports.SavingsCompoundingMethod = {}));
/**
 * A two character upper case state, Puerto Rico, or District of Columbia code
 * @export
 * @enum {string}
 */
var State;
(function (State) {
    State["AK"] = "AK";
    State["AL"] = "AL";
    State["AR"] = "AR";
    State["AZ"] = "AZ";
    State["CA"] = "CA";
    State["CO"] = "CO";
    State["CT"] = "CT";
    State["DC"] = "DC";
    State["DE"] = "DE";
    State["FL"] = "FL";
    State["GA"] = "GA";
    State["HI"] = "HI";
    State["IA"] = "IA";
    State["ID"] = "ID";
    State["IL"] = "IL";
    State["IN"] = "IN";
    State["KS"] = "KS";
    State["KY"] = "KY";
    State["LA"] = "LA";
    State["MA"] = "MA";
    State["MD"] = "MD";
    State["ME"] = "ME";
    State["MI"] = "MI";
    State["MN"] = "MN";
    State["MO"] = "MO";
    State["MS"] = "MS";
    State["MT"] = "MT";
    State["NC"] = "NC";
    State["ND"] = "ND";
    State["NE"] = "NE";
    State["NH"] = "NH";
    State["NJ"] = "NJ";
    State["NM"] = "NM";
    State["NV"] = "NV";
    State["NY"] = "NY";
    State["OH"] = "OH";
    State["OK"] = "OK";
    State["OR"] = "OR";
    State["PA"] = "PA";
    State["PR"] = "PR";
    State["RI"] = "RI";
    State["SC"] = "SC";
    State["SD"] = "SD";
    State["TN"] = "TN";
    State["TX"] = "TX";
    State["UT"] = "UT";
    State["VA"] = "VA";
    State["VI"] = "VI";
    State["VT"] = "VT";
    State["WA"] = "WA";
    State["WI"] = "WI";
    State["WV"] = "WV";
    State["WY"] = "WY";
})(State = exports.State || (exports.State = {}));
/**
 * The key used to identify from where the survey was submitted.
 * @export
 * @enum {string}
 */
var SubmittedFrom;
(function (SubmittedFrom) {
    SubmittedFrom["AppResults"] = "app_results";
    SubmittedFrom["RemarketingEmail"] = "remarketing_email";
    SubmittedFrom["TransactionalEmail"] = "transactional_email";
})(SubmittedFrom = exports.SubmittedFrom || (exports.SubmittedFrom = {}));
/**
 * The key used to identify which survey the result is for.
 * @export
 * @enum {string}
 */
var SurveyKey;
(function (SurveyKey) {
    SurveyKey["LeadSentiment"] = "lead_sentiment";
})(SurveyKey = exports.SurveyKey || (exports.SurveyKey = {}));
/**
 *
 * @export
 * @enum {string}
 */
var TimestampField;
(function (TimestampField) {
    TimestampField["CreatedAt"] = "createdAt";
    TimestampField["UpdatedAt"] = "updatedAt";
})(TimestampField = exports.TimestampField || (exports.TimestampField = {}));
/**
 * ClientTagApi - axios parameter creator
 * @export
 */
exports.ClientTagApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all client tags for a set of leads.
         * @param {Array<string>} leadUuid
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The offset of resources to include in the results.
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientTags: function (leadUuid, limit, offset, sortBy, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadUuid' is not null or undefined
            if (leadUuid === null || leadUuid === undefined) {
                throw new base_1.RequiredError('leadUuid', 'Required parameter leadUuid was null or undefined when calling getClientTags.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new base_1.RequiredError('limit', 'Required parameter limit was null or undefined when calling getClientTags.');
            }
            var localVarPath = "/leads/clientTags";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (leadUuid) {
                localVarQueryParameter['leadUuid'] = leadUuid;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ClientTagApi - functional programming interface
 * @export
 */
exports.ClientTagApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get all client tags for a set of leads.
         * @param {Array<string>} leadUuid
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The offset of resources to include in the results.
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientTags: function (leadUuid, limit, offset, sortBy, options) {
            var localVarAxiosArgs = exports.ClientTagApiAxiosParamCreator(configuration).getClientTags(leadUuid, limit, offset, sortBy, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ClientTagApi - factory interface
 * @export
 */
exports.ClientTagApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get all client tags for a set of leads.
         * @param {Array<string>} leadUuid
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {number} [offset] The offset of resources to include in the results.
         * @param {string} [sortBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientTags: function (leadUuid, limit, offset, sortBy, options) {
            return exports.ClientTagApiFp(configuration).getClientTags(leadUuid, limit, offset, sortBy, options)(axios, basePath);
        },
    };
};
/**
 * ClientTagApi - object-oriented interface
 * @export
 * @class ClientTagApi
 * @extends {BaseAPI}
 */
var ClientTagApi = /** @class */ (function (_super) {
    __extends(ClientTagApi, _super);
    function ClientTagApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all client tags for a set of leads.
     * @param {Array<string>} leadUuid
     * @param {number} limit The maximum number of resources to include in the results.
     * @param {number} [offset] The offset of resources to include in the results.
     * @param {string} [sortBy]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientTagApi
     */
    ClientTagApi.prototype.getClientTags = function (leadUuid, limit, offset, sortBy, options) {
        return exports.ClientTagApiFp(this.configuration).getClientTags(leadUuid, limit, offset, sortBy, options)(this.axios, this.basePath);
    };
    return ClientTagApi;
}(base_1.BaseAPI));
exports.ClientTagApi = ClientTagApi;
/**
 * DeduplicationConfigurationApi - axios parameter creator
 * @export
 */
exports.DeduplicationConfigurationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Create a deduplication configuration. Must specify exactly one of `supplySubAccountId` or `supplySubAccountUuid`, otherwise an error will be returned.
         * @summary Create a deduplication configuration
         * @param {NewDeduplicationConfiguration} newDeduplicationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeduplicationConfiguration: function (newDeduplicationConfiguration, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'newDeduplicationConfiguration' is not null or undefined
            if (newDeduplicationConfiguration === null || newDeduplicationConfiguration === undefined) {
                throw new base_1.RequiredError('newDeduplicationConfiguration', 'Required parameter newDeduplicationConfiguration was null or undefined when calling createDeduplicationConfiguration.');
            }
            var localVarPath = "/admin/deduplicationConfigurations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:write"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof newDeduplicationConfiguration !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(newDeduplicationConfiguration !== undefined ? newDeduplicationConfiguration : {}) : (newDeduplicationConfiguration || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a deduplication configuration
         * @summary Delete a deduplication configuration
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeduplicationConfiguration: function (id, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new base_1.RequiredError('id', 'Required parameter id was null or undefined when calling deleteDeduplicationConfiguration.');
            }
            var localVarPath = "/admin/deduplicationConfigurations/{id}"
                .replace("{" + "id" + "}", encodeURIComponent(String(id)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:write"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return deduplication configurations based upon request parameters
         * @summary Get deduplication configurations
         * @param {Array<number>} [id]
         * @param {number} [supplySubAccountId]
         * @param {string} [supplySubAccountUuid]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {DeduplicationConfigurationSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeduplicationConfigurations: function (id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/admin/deduplicationConfigurations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (id) {
                localVarQueryParameter['id'] = id;
            }
            if (supplySubAccountId !== undefined) {
                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
            }
            if (supplySubAccountUuid !== undefined) {
                localVarQueryParameter['supplySubAccountUuid'] = supplySubAccountUuid;
            }
            if (includeDeleted !== undefined) {
                localVarQueryParameter['includeDeleted'] = includeDeleted;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DeduplicationConfigurationApi - functional programming interface
 * @export
 */
exports.DeduplicationConfigurationApiFp = function (configuration) {
    return {
        /**
         * Create a deduplication configuration. Must specify exactly one of `supplySubAccountId` or `supplySubAccountUuid`, otherwise an error will be returned.
         * @summary Create a deduplication configuration
         * @param {NewDeduplicationConfiguration} newDeduplicationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeduplicationConfiguration: function (newDeduplicationConfiguration, options) {
            var localVarAxiosArgs = exports.DeduplicationConfigurationApiAxiosParamCreator(configuration).createDeduplicationConfiguration(newDeduplicationConfiguration, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a deduplication configuration
         * @summary Delete a deduplication configuration
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeduplicationConfiguration: function (id, options) {
            var localVarAxiosArgs = exports.DeduplicationConfigurationApiAxiosParamCreator(configuration).deleteDeduplicationConfiguration(id, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Return deduplication configurations based upon request parameters
         * @summary Get deduplication configurations
         * @param {Array<number>} [id]
         * @param {number} [supplySubAccountId]
         * @param {string} [supplySubAccountUuid]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {DeduplicationConfigurationSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeduplicationConfigurations: function (id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options) {
            var localVarAxiosArgs = exports.DeduplicationConfigurationApiAxiosParamCreator(configuration).getDeduplicationConfigurations(id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DeduplicationConfigurationApi - factory interface
 * @export
 */
exports.DeduplicationConfigurationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Create a deduplication configuration. Must specify exactly one of `supplySubAccountId` or `supplySubAccountUuid`, otherwise an error will be returned.
         * @summary Create a deduplication configuration
         * @param {NewDeduplicationConfiguration} newDeduplicationConfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDeduplicationConfiguration: function (newDeduplicationConfiguration, options) {
            return exports.DeduplicationConfigurationApiFp(configuration).createDeduplicationConfiguration(newDeduplicationConfiguration, options)(axios, basePath);
        },
        /**
         * Delete a deduplication configuration
         * @summary Delete a deduplication configuration
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDeduplicationConfiguration: function (id, options) {
            return exports.DeduplicationConfigurationApiFp(configuration).deleteDeduplicationConfiguration(id, options)(axios, basePath);
        },
        /**
         * Return deduplication configurations based upon request parameters
         * @summary Get deduplication configurations
         * @param {Array<number>} [id]
         * @param {number} [supplySubAccountId]
         * @param {string} [supplySubAccountUuid]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {DeduplicationConfigurationSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeduplicationConfigurations: function (id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options) {
            return exports.DeduplicationConfigurationApiFp(configuration).getDeduplicationConfigurations(id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options)(axios, basePath);
        },
    };
};
/**
 * DeduplicationConfigurationApi - object-oriented interface
 * @export
 * @class DeduplicationConfigurationApi
 * @extends {BaseAPI}
 */
var DeduplicationConfigurationApi = /** @class */ (function (_super) {
    __extends(DeduplicationConfigurationApi, _super);
    function DeduplicationConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a deduplication configuration. Must specify exactly one of `supplySubAccountId` or `supplySubAccountUuid`, otherwise an error will be returned.
     * @summary Create a deduplication configuration
     * @param {NewDeduplicationConfiguration} newDeduplicationConfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeduplicationConfigurationApi
     */
    DeduplicationConfigurationApi.prototype.createDeduplicationConfiguration = function (newDeduplicationConfiguration, options) {
        return exports.DeduplicationConfigurationApiFp(this.configuration).createDeduplicationConfiguration(newDeduplicationConfiguration, options)(this.axios, this.basePath);
    };
    /**
     * Delete a deduplication configuration
     * @summary Delete a deduplication configuration
     * @param {number} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeduplicationConfigurationApi
     */
    DeduplicationConfigurationApi.prototype.deleteDeduplicationConfiguration = function (id, options) {
        return exports.DeduplicationConfigurationApiFp(this.configuration).deleteDeduplicationConfiguration(id, options)(this.axios, this.basePath);
    };
    /**
     * Return deduplication configurations based upon request parameters
     * @summary Get deduplication configurations
     * @param {Array<number>} [id]
     * @param {number} [supplySubAccountId]
     * @param {string} [supplySubAccountUuid]
     * @param {boolean} [includeDeleted]
     * @param {number} [offset] The number of resources to skip before the first resource in the results.
     * @param {number} [limit] The maximum number of resources to include in the results.
     * @param {DeduplicationConfigurationSort} [sortBy] The attribute with which to sort the resources.
     * @param {Order} [order] The direction to use for ordering resources.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeduplicationConfigurationApi
     */
    DeduplicationConfigurationApi.prototype.getDeduplicationConfigurations = function (id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options) {
        return exports.DeduplicationConfigurationApiFp(this.configuration).getDeduplicationConfigurations(id, supplySubAccountId, supplySubAccountUuid, includeDeleted, offset, limit, sortBy, order, options)(this.axios, this.basePath);
    };
    return DeduplicationConfigurationApi;
}(base_1.BaseAPI));
exports.DeduplicationConfigurationApi = DeduplicationConfigurationApi;
/**
 * LeadApi - axios parameter creator
 * @export
 */
exports.LeadApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a lead
         * @param {LeadRequest} leadRequest A lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (leadRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadRequest' is not null or undefined
            if (leadRequest === null || leadRequest === undefined) {
                throw new base_1.RequiredError('leadRequest', 'Required parameter leadRequest was null or undefined when calling createLead.');
            }
            var localVarPath = "/leads";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:insert", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadRequest !== undefined ? leadRequest : {}) : (leadRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Return a `Lead` given its UUID. Depending on the access token scope, the response may contain a subset of a `Lead` object.
         * @summary Get a lead
         * @param {string} uuid The UUID of the lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (uuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new base_1.RequiredError('uuid', 'Required parameter uuid was null or undefined when calling getLead.');
            }
            var localVarPath = "/leads/{uuid}"
                .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:readAll"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get leads
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeads: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:readAll"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (uuid) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (email) {
                localVarQueryParameter['email'] = email;
            }
            if (credit) {
                localVarQueryParameter['credit'] = credit;
            }
            if (productType) {
                localVarQueryParameter['productType'] = productType;
            }
            if (timestampField !== undefined) {
                localVarQueryParameter['timestampField'] = timestampField;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (company) {
                localVarQueryParameter['company'] = company;
            }
            if (test !== undefined) {
                localVarQueryParameter['test'] = test;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A shorthand operation for `POST /leads` followed by a `POST /originator/rateTables`. The response `RateTable` must still be queried until there are no more `pendingResponses`
         * @summary Submit a lead and get a rate table
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableForLead: function (leadRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadRequest' is not null or undefined
            if (leadRequest === null || leadRequest === undefined) {
                throw new base_1.RequiredError('leadRequest', 'Required parameter leadRequest was null or undefined when calling getRateTableForLead.');
            }
            var localVarPath = "/leads/rateTables";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:insert", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadRequest !== undefined ? leadRequest : {}) : (leadRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Similar to `POST /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is created by an internal service.
         * @summary Insert a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertLeadWithCompany: function (accountUuid, leadRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountUuid' is not null or undefined
            if (accountUuid === null || accountUuid === undefined) {
                throw new base_1.RequiredError('accountUuid', 'Required parameter accountUuid was null or undefined when calling insertLeadWithCompany.');
            }
            // verify required parameter 'leadRequest' is not null or undefined
            if (leadRequest === null || leadRequest === undefined) {
                throw new base_1.RequiredError('leadRequest', 'Required parameter leadRequest was null or undefined when calling insertLeadWithCompany.');
            }
            var localVarPath = "/leads/accounts/{accountUuid}"
                .replace("{" + "accountUuid" + "}", encodeURIComponent(String(accountUuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:insert", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadRequest !== undefined ? leadRequest : {}) : (leadRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a `Lead` by its UUID. Array fields (like `productTypes`) with new values are _merged_ with existing values.
         * @summary Update a lead
         * @param {string} uuid The UUID of the lead
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (uuid, leadRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new base_1.RequiredError('uuid', 'Required parameter uuid was null or undefined when calling updateLead.');
            }
            // verify required parameter 'leadRequest' is not null or undefined
            if (leadRequest === null || leadRequest === undefined) {
                throw new base_1.RequiredError('leadRequest', 'Required parameter leadRequest was null or undefined when calling updateLead.');
            }
            var localVarPath = "/leads/{uuid}"
                .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:insert", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadRequest !== undefined ? leadRequest : {}) : (leadRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Similar to `PATCH /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is updated by an internal service.
         * @summary Update a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadWithCompany: function (accountUuid, leadRequest, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'accountUuid' is not null or undefined
            if (accountUuid === null || accountUuid === undefined) {
                throw new base_1.RequiredError('accountUuid', 'Required parameter accountUuid was null or undefined when calling updateLeadWithCompany.');
            }
            // verify required parameter 'leadRequest' is not null or undefined
            if (leadRequest === null || leadRequest === undefined) {
                throw new base_1.RequiredError('leadRequest', 'Required parameter leadRequest was null or undefined when calling updateLeadWithCompany.');
            }
            var localVarPath = "/leads/accounts/{accountUuid}"
                .replace("{" + "accountUuid" + "}", encodeURIComponent(String(accountUuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'PATCH' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:insert", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadRequest !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadRequest !== undefined ? leadRequest : {}) : (leadRequest || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadApi - functional programming interface
 * @export
 */
exports.LeadApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Create a lead
         * @param {LeadRequest} leadRequest A lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (leadRequest, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).createLead(leadRequest, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Return a `Lead` given its UUID. Depending on the access token scope, the response may contain a subset of a `Lead` object.
         * @summary Get a lead
         * @param {string} uuid The UUID of the lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (uuid, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).getLead(uuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get leads
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeads: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).getLeads(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * A shorthand operation for `POST /leads` followed by a `POST /originator/rateTables`. The response `RateTable` must still be queried until there are no more `pendingResponses`
         * @summary Submit a lead and get a rate table
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableForLead: function (leadRequest, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).getRateTableForLead(leadRequest, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Similar to `POST /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is created by an internal service.
         * @summary Insert a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertLeadWithCompany: function (accountUuid, leadRequest, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).insertLeadWithCompany(accountUuid, leadRequest, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a `Lead` by its UUID. Array fields (like `productTypes`) with new values are _merged_ with existing values.
         * @summary Update a lead
         * @param {string} uuid The UUID of the lead
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (uuid, leadRequest, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).updateLead(uuid, leadRequest, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Similar to `PATCH /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is updated by an internal service.
         * @summary Update a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadWithCompany: function (accountUuid, leadRequest, options) {
            var localVarAxiosArgs = exports.LeadApiAxiosParamCreator(configuration).updateLeadWithCompany(accountUuid, leadRequest, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LeadApi - factory interface
 * @export
 */
exports.LeadApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Create a lead
         * @param {LeadRequest} leadRequest A lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLead: function (leadRequest, options) {
            return exports.LeadApiFp(configuration).createLead(leadRequest, options)(axios, basePath);
        },
        /**
         * Return a `Lead` given its UUID. Depending on the access token scope, the response may contain a subset of a `Lead` object.
         * @summary Get a lead
         * @param {string} uuid The UUID of the lead
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLead: function (uuid, options) {
            return exports.LeadApiFp(configuration).getLead(uuid, options)(axios, basePath);
        },
        /**
         *
         * @summary Get leads
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeads: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options) {
            return exports.LeadApiFp(configuration).getLeads(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options)(axios, basePath);
        },
        /**
         * A shorthand operation for `POST /leads` followed by a `POST /originator/rateTables`. The response `RateTable` must still be queried until there are no more `pendingResponses`
         * @summary Submit a lead and get a rate table
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRateTableForLead: function (leadRequest, options) {
            return exports.LeadApiFp(configuration).getRateTableForLead(leadRequest, options)(axios, basePath);
        },
        /**
         * Similar to `POST /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is created by an internal service.
         * @summary Insert a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insertLeadWithCompany: function (accountUuid, leadRequest, options) {
            return exports.LeadApiFp(configuration).insertLeadWithCompany(accountUuid, leadRequest, options)(axios, basePath);
        },
        /**
         * Update a `Lead` by its UUID. Array fields (like `productTypes`) with new values are _merged_ with existing values.
         * @summary Update a lead
         * @param {string} uuid The UUID of the lead
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLead: function (uuid, leadRequest, options) {
            return exports.LeadApiFp(configuration).updateLead(uuid, leadRequest, options)(axios, basePath);
        },
        /**
         * Similar to `PATCH /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is updated by an internal service.
         * @summary Update a lead
         * @param {string} accountUuid The UUID of the company that the lead is originated from.
         * @param {LeadRequest} leadRequest A Lead object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLeadWithCompany: function (accountUuid, leadRequest, options) {
            return exports.LeadApiFp(configuration).updateLeadWithCompany(accountUuid, leadRequest, options)(axios, basePath);
        },
    };
};
/**
 * LeadApi - object-oriented interface
 * @export
 * @class LeadApi
 * @extends {BaseAPI}
 */
var LeadApi = /** @class */ (function (_super) {
    __extends(LeadApi, _super);
    function LeadApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a lead
     * @param {LeadRequest} leadRequest A lead object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.createLead = function (leadRequest, options) {
        return exports.LeadApiFp(this.configuration).createLead(leadRequest, options)(this.axios, this.basePath);
    };
    /**
     * Return a `Lead` given its UUID. Depending on the access token scope, the response may contain a subset of a `Lead` object.
     * @summary Get a lead
     * @param {string} uuid The UUID of the lead
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.getLead = function (uuid, options) {
        return exports.LeadApiFp(this.configuration).getLead(uuid, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get leads
     * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
     * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
     * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
     * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
     * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
     * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
     * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
     * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified UUIDs
     * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
     * @param {Array<LeadActionType>} [status]
     * @param {Order} [sortDirection]
     * @param {number} [offset] The number of resources to skip before the first resource in the results.
     * @param {number} [limit] The maximum number of resources to include in the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.getLeads = function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options) {
        return exports.LeadApiFp(this.configuration).getLeads(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     * A shorthand operation for `POST /leads` followed by a `POST /originator/rateTables`. The response `RateTable` must still be queried until there are no more `pendingResponses`
     * @summary Submit a lead and get a rate table
     * @param {LeadRequest} leadRequest A Lead object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.getRateTableForLead = function (leadRequest, options) {
        return exports.LeadApiFp(this.configuration).getRateTableForLead(leadRequest, options)(this.axios, this.basePath);
    };
    /**
     * Similar to `POST /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is created by an internal service.
     * @summary Insert a lead
     * @param {string} accountUuid The UUID of the company that the lead is originated from.
     * @param {LeadRequest} leadRequest A Lead object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.insertLeadWithCompany = function (accountUuid, leadRequest, options) {
        return exports.LeadApiFp(this.configuration).insertLeadWithCompany(accountUuid, leadRequest, options)(this.axios, this.basePath);
    };
    /**
     * Update a `Lead` by its UUID. Array fields (like `productTypes`) with new values are _merged_ with existing values.
     * @summary Update a lead
     * @param {string} uuid The UUID of the lead
     * @param {LeadRequest} leadRequest A Lead object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.updateLead = function (uuid, leadRequest, options) {
        return exports.LeadApiFp(this.configuration).updateLead(uuid, leadRequest, options)(this.axios, this.basePath);
    };
    /**
     * Similar to `PATCH /leads/{uuid}` endpoint, with overriding of `companyUuid` field in the lead with the given account uuid. This endpoint is used when a lead is updated by an internal service.
     * @summary Update a lead
     * @param {string} accountUuid The UUID of the company that the lead is originated from.
     * @param {LeadRequest} leadRequest A Lead object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadApi
     */
    LeadApi.prototype.updateLeadWithCompany = function (accountUuid, leadRequest, options) {
        return exports.LeadApiFp(this.configuration).updateLeadWithCompany(accountUuid, leadRequest, options)(this.axios, this.basePath);
    };
    return LeadApi;
}(base_1.BaseAPI));
exports.LeadApi = LeadApi;
/**
 * LeadSummariesApi - axios parameter creator
 * @export
 */
exports.LeadSummariesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Return lead summaries based upon request parameters
         * @summary Get lead summaries
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified company UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {Array<string>} [supplySubAccountUuid] Limits the result by supply sub account uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSummaries: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leadSummaries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:leads:readAll"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (uuid) {
                localVarQueryParameter['uuid'] = uuid;
            }
            if (email) {
                localVarQueryParameter['email'] = email;
            }
            if (credit) {
                localVarQueryParameter['credit'] = credit;
            }
            if (productType) {
                localVarQueryParameter['productType'] = productType;
            }
            if (timestampField !== undefined) {
                localVarQueryParameter['timestampField'] = timestampField;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = (from instanceof Date) ?
                    from.toISOString() :
                    from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = (to instanceof Date) ?
                    to.toISOString() :
                    to;
            }
            if (company) {
                localVarQueryParameter['company'] = company;
            }
            if (test !== undefined) {
                localVarQueryParameter['test'] = test;
            }
            if (status) {
                localVarQueryParameter['status'] = status;
            }
            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (supplySubAccountUuid) {
                localVarQueryParameter['supplySubAccountUuid'] = supplySubAccountUuid;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadSummariesApi - functional programming interface
 * @export
 */
exports.LeadSummariesApiFp = function (configuration) {
    return {
        /**
         * Return lead summaries based upon request parameters
         * @summary Get lead summaries
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified company UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {Array<string>} [supplySubAccountUuid] Limits the result by supply sub account uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSummaries: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options) {
            var localVarAxiosArgs = exports.LeadSummariesApiAxiosParamCreator(configuration).getLeadSummaries(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LeadSummariesApi - factory interface
 * @export
 */
exports.LeadSummariesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         * Return lead summaries based upon request parameters
         * @summary Get lead summaries
         * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
         * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
         * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
         * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
         * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
         * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
         * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified company UUIDs
         * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
         * @param {Array<LeadActionType>} [status]
         * @param {Order} [sortDirection]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {number} [limit] The maximum number of resources to include in the results.
         * @param {Array<string>} [supplySubAccountUuid] Limits the result by supply sub account uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSummaries: function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options) {
            return exports.LeadSummariesApiFp(configuration).getLeadSummaries(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options)(axios, basePath);
        },
    };
};
/**
 * LeadSummariesApi - object-oriented interface
 * @export
 * @class LeadSummariesApi
 * @extends {BaseAPI}
 */
var LeadSummariesApi = /** @class */ (function (_super) {
    __extends(LeadSummariesApi, _super);
    function LeadSummariesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return lead summaries based upon request parameters
     * @summary Get lead summaries
     * @param {Array<string>} [uuid] Limits results to leads with the specified UUIDs.
     * @param {Array<string>} [email] Limits results to leads with the specified email addresses.
     * @param {Array<ProvidedCreditRating>} [credit] Limits results to leads that have the specified self-assessed credit bands.
     * @param {Array<ProductType>} [productType] Limits results to leads that have the specified product types
     * @param {TimestampField} [timestampField] Defines the timestamp to consider for the &#x60;from&#x60; and &#x60;to&#x60; parameters.
     * @param {Date} [from] The earliest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
     * @param {Date} [to] The latest timestamp to include in the result set. Will either match against &#x60;createdAt&#x60; or &#x60;updatedAt&#x60;, depending on the value of the &#x60;timestampField&#x60; parameter.
     * @param {Array<string>} [company] Limits the result set to leads belonging the companies with the specified company UUIDs
     * @param {boolean} [test] When true, only returns test leads; otherwise, only returns non-test leads
     * @param {Array<LeadActionType>} [status]
     * @param {Order} [sortDirection]
     * @param {number} [offset] The number of resources to skip before the first resource in the results.
     * @param {number} [limit] The maximum number of resources to include in the results.
     * @param {Array<string>} [supplySubAccountUuid] Limits the result by supply sub account uuid
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadSummariesApi
     */
    LeadSummariesApi.prototype.getLeadSummaries = function (uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options) {
        return exports.LeadSummariesApiFp(this.configuration).getLeadSummaries(uuid, email, credit, productType, timestampField, from, to, company, test, status, sortDirection, offset, limit, supplySubAccountUuid, options)(this.axios, this.basePath);
    };
    return LeadSummariesApi;
}(base_1.BaseAPI));
exports.LeadSummariesApi = LeadSummariesApi;
/**
 * LeadSurveyResultApi - axios parameter creator
 * @export
 */
exports.LeadSurveyResultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Submit results for a lead survey
         * @param {LeadSurveyResultCreateData} [leadSurveyResultCreateData] A Lead Survey Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSurveyResult: function (leadSurveyResultCreateData, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/admin/leadSurveyResults";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof leadSurveyResultCreateData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(leadSurveyResultCreateData !== undefined ? leadSurveyResultCreateData : {}) : (leadSurveyResultCreateData || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get the results for lead surveys
         * @param {string} leadUuid
         * @param {number} limit
         * @param {SurveyKey} [surveyKey]
         * @param {number} [offset]
         * @param {LeadSurveyResultSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSurveyResults: function (leadUuid, limit, surveyKey, offset, sortBy, order, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'leadUuid' is not null or undefined
            if (leadUuid === null || leadUuid === undefined) {
                throw new base_1.RequiredError('leadUuid', 'Required parameter leadUuid was null or undefined when calling getLeadSurveyResults.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new base_1.RequiredError('limit', 'Required parameter limit was null or undefined when calling getLeadSurveyResults.');
            }
            var localVarPath = "/admin/leadSurveyResults";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (leadUuid !== undefined) {
                localVarQueryParameter['leadUuid'] = leadUuid;
            }
            if (surveyKey !== undefined) {
                localVarQueryParameter['surveyKey'] = surveyKey;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }
            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * LeadSurveyResultApi - functional programming interface
 * @export
 */
exports.LeadSurveyResultApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Submit results for a lead survey
         * @param {LeadSurveyResultCreateData} [leadSurveyResultCreateData] A Lead Survey Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSurveyResult: function (leadSurveyResultCreateData, options) {
            var localVarAxiosArgs = exports.LeadSurveyResultApiAxiosParamCreator(configuration).createLeadSurveyResult(leadSurveyResultCreateData, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get the results for lead surveys
         * @param {string} leadUuid
         * @param {number} limit
         * @param {SurveyKey} [surveyKey]
         * @param {number} [offset]
         * @param {LeadSurveyResultSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSurveyResults: function (leadUuid, limit, surveyKey, offset, sortBy, order, options) {
            var localVarAxiosArgs = exports.LeadSurveyResultApiAxiosParamCreator(configuration).getLeadSurveyResults(leadUuid, limit, surveyKey, offset, sortBy, order, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * LeadSurveyResultApi - factory interface
 * @export
 */
exports.LeadSurveyResultApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Submit results for a lead survey
         * @param {LeadSurveyResultCreateData} [leadSurveyResultCreateData] A Lead Survey Result
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLeadSurveyResult: function (leadSurveyResultCreateData, options) {
            return exports.LeadSurveyResultApiFp(configuration).createLeadSurveyResult(leadSurveyResultCreateData, options)(axios, basePath);
        },
        /**
         *
         * @summary Get the results for lead surveys
         * @param {string} leadUuid
         * @param {number} limit
         * @param {SurveyKey} [surveyKey]
         * @param {number} [offset]
         * @param {LeadSurveyResultSortBy} [sortBy]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadSurveyResults: function (leadUuid, limit, surveyKey, offset, sortBy, order, options) {
            return exports.LeadSurveyResultApiFp(configuration).getLeadSurveyResults(leadUuid, limit, surveyKey, offset, sortBy, order, options)(axios, basePath);
        },
    };
};
/**
 * LeadSurveyResultApi - object-oriented interface
 * @export
 * @class LeadSurveyResultApi
 * @extends {BaseAPI}
 */
var LeadSurveyResultApi = /** @class */ (function (_super) {
    __extends(LeadSurveyResultApi, _super);
    function LeadSurveyResultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Submit results for a lead survey
     * @param {LeadSurveyResultCreateData} [leadSurveyResultCreateData] A Lead Survey Result
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadSurveyResultApi
     */
    LeadSurveyResultApi.prototype.createLeadSurveyResult = function (leadSurveyResultCreateData, options) {
        return exports.LeadSurveyResultApiFp(this.configuration).createLeadSurveyResult(leadSurveyResultCreateData, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get the results for lead surveys
     * @param {string} leadUuid
     * @param {number} limit
     * @param {SurveyKey} [surveyKey]
     * @param {number} [offset]
     * @param {LeadSurveyResultSortBy} [sortBy]
     * @param {Order} [order]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadSurveyResultApi
     */
    LeadSurveyResultApi.prototype.getLeadSurveyResults = function (leadUuid, limit, surveyKey, offset, sortBy, order, options) {
        return exports.LeadSurveyResultApiFp(this.configuration).getLeadSurveyResults(leadUuid, limit, surveyKey, offset, sortBy, order, options)(this.axios, this.basePath);
    };
    return LeadSurveyResultApi;
}(base_1.BaseAPI));
exports.LeadSurveyResultApi = LeadSurveyResultApi;
/**
 * NadaVehiclesApi - axios parameter creator
 * @export
 */
exports.NadaVehiclesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Create a Vehicle
         * @param {VehicleCreateData} vehicleCreateData Vehicle create data object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle: function (vehicleCreateData, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'vehicleCreateData' is not null or undefined
            if (vehicleCreateData === null || vehicleCreateData === undefined) {
                throw new base_1.RequiredError('vehicleCreateData', 'Required parameter vehicleCreateData was null or undefined when calling createVehicle.');
            }
            var localVarPath = "/leads/vehicles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:write"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof vehicleCreateData !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(vehicleCreateData !== undefined ? vehicleCreateData : {}) : (vehicleCreateData || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get NADA year, make, model, and trim for the given uuid
         * @summary Get NADA year, make, model, and trim for the given uuid
         * @param {string} uuid The UUID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNadaVehicleInformation: function (uuid, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'uuid' is not null or undefined
            if (uuid === null || uuid === undefined) {
                throw new base_1.RequiredError('uuid', 'Required parameter uuid was null or undefined when calling getNadaVehicleInformation.');
            }
            var localVarPath = "/leads/vehicles/{uuid}"
                .replace("{" + "uuid" + "}", encodeURIComponent(String(uuid)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all available NADA years
         * @summary Get all available NADA years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidNadaYears: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads/vehicles/years";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all makes for the given NADA year
         * @summary Get all makes for the given NADA year
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleMakes: function (year, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads/vehicles/makes";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all models for the given NADA year and make
         * @summary Get all models for the given NADA year and make
         * @param {number} [year]
         * @param {string} [make]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleModels: function (year, make, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads/vehicles/models";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (make !== undefined) {
                localVarQueryParameter['make'] = make;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all trim and uuid pairs for the given NADA year, make, and model
         * @summary Get all trim and uuid pairs for the given NADA year, make, and model
         * @param {number} [year]
         * @param {string} [make]
         * @param {string} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleTrims: function (year, make, model, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads/vehicles/trims";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }
            if (make !== undefined) {
                localVarQueryParameter['make'] = make;
            }
            if (model !== undefined) {
                localVarQueryParameter['model'] = model;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NadaVehiclesApi - functional programming interface
 * @export
 */
exports.NadaVehiclesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Create a Vehicle
         * @param {VehicleCreateData} vehicleCreateData Vehicle create data object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle: function (vehicleCreateData, options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).createVehicle(vehicleCreateData, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get NADA year, make, model, and trim for the given uuid
         * @summary Get NADA year, make, model, and trim for the given uuid
         * @param {string} uuid The UUID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNadaVehicleInformation: function (uuid, options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).getNadaVehicleInformation(uuid, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all available NADA years
         * @summary Get all available NADA years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidNadaYears: function (options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).getValidNadaYears(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all makes for the given NADA year
         * @summary Get all makes for the given NADA year
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleMakes: function (year, options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).getVehicleMakes(year, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all models for the given NADA year and make
         * @summary Get all models for the given NADA year and make
         * @param {number} [year]
         * @param {string} [make]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleModels: function (year, make, options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).getVehicleModels(year, make, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get all trim and uuid pairs for the given NADA year, make, and model
         * @summary Get all trim and uuid pairs for the given NADA year, make, and model
         * @param {number} [year]
         * @param {string} [make]
         * @param {string} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleTrims: function (year, make, model, options) {
            var localVarAxiosArgs = exports.NadaVehiclesApiAxiosParamCreator(configuration).getVehicleTrims(year, make, model, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * NadaVehiclesApi - factory interface
 * @export
 */
exports.NadaVehiclesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Create a Vehicle
         * @param {VehicleCreateData} vehicleCreateData Vehicle create data object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createVehicle: function (vehicleCreateData, options) {
            return exports.NadaVehiclesApiFp(configuration).createVehicle(vehicleCreateData, options)(axios, basePath);
        },
        /**
         * Get NADA year, make, model, and trim for the given uuid
         * @summary Get NADA year, make, model, and trim for the given uuid
         * @param {string} uuid The UUID of the vehicle
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNadaVehicleInformation: function (uuid, options) {
            return exports.NadaVehiclesApiFp(configuration).getNadaVehicleInformation(uuid, options)(axios, basePath);
        },
        /**
         * Get all available NADA years
         * @summary Get all available NADA years
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidNadaYears: function (options) {
            return exports.NadaVehiclesApiFp(configuration).getValidNadaYears(options)(axios, basePath);
        },
        /**
         * Get all makes for the given NADA year
         * @summary Get all makes for the given NADA year
         * @param {number} [year]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleMakes: function (year, options) {
            return exports.NadaVehiclesApiFp(configuration).getVehicleMakes(year, options)(axios, basePath);
        },
        /**
         * Get all models for the given NADA year and make
         * @summary Get all models for the given NADA year and make
         * @param {number} [year]
         * @param {string} [make]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleModels: function (year, make, options) {
            return exports.NadaVehiclesApiFp(configuration).getVehicleModels(year, make, options)(axios, basePath);
        },
        /**
         * Get all trim and uuid pairs for the given NADA year, make, and model
         * @summary Get all trim and uuid pairs for the given NADA year, make, and model
         * @param {number} [year]
         * @param {string} [make]
         * @param {string} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVehicleTrims: function (year, make, model, options) {
            return exports.NadaVehiclesApiFp(configuration).getVehicleTrims(year, make, model, options)(axios, basePath);
        },
    };
};
/**
 * NadaVehiclesApi - object-oriented interface
 * @export
 * @class NadaVehiclesApi
 * @extends {BaseAPI}
 */
var NadaVehiclesApi = /** @class */ (function (_super) {
    __extends(NadaVehiclesApi, _super);
    function NadaVehiclesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a Vehicle
     * @param {VehicleCreateData} vehicleCreateData Vehicle create data object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.createVehicle = function (vehicleCreateData, options) {
        return exports.NadaVehiclesApiFp(this.configuration).createVehicle(vehicleCreateData, options)(this.axios, this.basePath);
    };
    /**
     * Get NADA year, make, model, and trim for the given uuid
     * @summary Get NADA year, make, model, and trim for the given uuid
     * @param {string} uuid The UUID of the vehicle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.getNadaVehicleInformation = function (uuid, options) {
        return exports.NadaVehiclesApiFp(this.configuration).getNadaVehicleInformation(uuid, options)(this.axios, this.basePath);
    };
    /**
     * Get all available NADA years
     * @summary Get all available NADA years
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.getValidNadaYears = function (options) {
        return exports.NadaVehiclesApiFp(this.configuration).getValidNadaYears(options)(this.axios, this.basePath);
    };
    /**
     * Get all makes for the given NADA year
     * @summary Get all makes for the given NADA year
     * @param {number} [year]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.getVehicleMakes = function (year, options) {
        return exports.NadaVehiclesApiFp(this.configuration).getVehicleMakes(year, options)(this.axios, this.basePath);
    };
    /**
     * Get all models for the given NADA year and make
     * @summary Get all models for the given NADA year and make
     * @param {number} [year]
     * @param {string} [make]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.getVehicleModels = function (year, make, options) {
        return exports.NadaVehiclesApiFp(this.configuration).getVehicleModels(year, make, options)(this.axios, this.basePath);
    };
    /**
     * Get all trim and uuid pairs for the given NADA year, make, and model
     * @summary Get all trim and uuid pairs for the given NADA year, make, and model
     * @param {number} [year]
     * @param {string} [make]
     * @param {string} [model]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NadaVehiclesApi
     */
    NadaVehiclesApi.prototype.getVehicleTrims = function (year, make, model, options) {
        return exports.NadaVehiclesApiFp(this.configuration).getVehicleTrims(year, make, model, options)(this.axios, this.basePath);
    };
    return NadaVehiclesApi;
}(base_1.BaseAPI));
exports.NadaVehiclesApi = NadaVehiclesApi;
/**
 * UniversityApi - axios parameter creator
 * @export
 */
exports.UniversityApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Get all available universites (limited to first 10000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUniversities: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/leads/admin/universities";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get universities by parameters
         * @summary Search universities by parameters
         * @param {number} limit
         * @param {string} [name]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniversities: function (limit, name, offset, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new base_1.RequiredError('limit', 'Required parameter limit was null or undefined when calling getUniversities.');
            }
            var localVarPath = "/leads/universities";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:read", "svc-lead:lead:insert", "svc-lead:leads:insert", "svc-lead:lead:insert-test", "svc-lead:leads:insert-test"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UniversityApi - functional programming interface
 * @export
 */
exports.UniversityApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Get all available universites (limited to first 10000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUniversities: function (options) {
            var localVarAxiosArgs = exports.UniversityApiAxiosParamCreator(configuration).getAllUniversities(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get universities by parameters
         * @summary Search universities by parameters
         * @param {number} limit
         * @param {string} [name]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniversities: function (limit, name, offset, options) {
            var localVarAxiosArgs = exports.UniversityApiAxiosParamCreator(configuration).getUniversities(limit, name, offset, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UniversityApi - factory interface
 * @export
 */
exports.UniversityApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Get all available universites (limited to first 10000)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUniversities: function (options) {
            return exports.UniversityApiFp(configuration).getAllUniversities(options)(axios, basePath);
        },
        /**
         * Get universities by parameters
         * @summary Search universities by parameters
         * @param {number} limit
         * @param {string} [name]
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUniversities: function (limit, name, offset, options) {
            return exports.UniversityApiFp(configuration).getUniversities(limit, name, offset, options)(axios, basePath);
        },
    };
};
/**
 * UniversityApi - object-oriented interface
 * @export
 * @class UniversityApi
 * @extends {BaseAPI}
 */
var UniversityApi = /** @class */ (function (_super) {
    __extends(UniversityApi, _super);
    function UniversityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Get all available universites (limited to first 10000)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UniversityApi
     */
    UniversityApi.prototype.getAllUniversities = function (options) {
        return exports.UniversityApiFp(this.configuration).getAllUniversities(options)(this.axios, this.basePath);
    };
    /**
     * Get universities by parameters
     * @summary Search universities by parameters
     * @param {number} limit
     * @param {string} [name]
     * @param {number} [offset]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UniversityApi
     */
    UniversityApi.prototype.getUniversities = function (limit, name, offset, options) {
        return exports.UniversityApiFp(this.configuration).getUniversities(limit, name, offset, options)(this.axios, this.basePath);
    };
    return UniversityApi;
}(base_1.BaseAPI));
exports.UniversityApi = UniversityApi;
/**
 * UpdateNadaVehicleDataJDPowerApi - axios parameter creator
 * @export
 */
exports.UpdateNadaVehicleDataJDPowerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Update Nada Vehicle Data from JD Power
         * @param {NadaVehicleUpdateCriteria} [nadaVehicleUpdateCriteria] Nada Vehicle Update Criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNadaVehicleData: function (nadaVehicleUpdateCriteria, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/admin/updateNadaVehicleData";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication oauth required
            // oauth required
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth", ["svc-lead:admin:write"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = __assign(__assign(__assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            var needsSerialization = (typeof nadaVehicleUpdateCriteria !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(nadaVehicleUpdateCriteria !== undefined ? nadaVehicleUpdateCriteria : {}) : (nadaVehicleUpdateCriteria || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UpdateNadaVehicleDataJDPowerApi - functional programming interface
 * @export
 */
exports.UpdateNadaVehicleDataJDPowerApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Update Nada Vehicle Data from JD Power
         * @param {NadaVehicleUpdateCriteria} [nadaVehicleUpdateCriteria] Nada Vehicle Update Criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNadaVehicleData: function (nadaVehicleUpdateCriteria, options) {
            var localVarAxiosArgs = exports.UpdateNadaVehicleDataJDPowerApiAxiosParamCreator(configuration).updateNadaVehicleData(nadaVehicleUpdateCriteria, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign(__assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UpdateNadaVehicleDataJDPowerApi - factory interface
 * @export
 */
exports.UpdateNadaVehicleDataJDPowerApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Update Nada Vehicle Data from JD Power
         * @param {NadaVehicleUpdateCriteria} [nadaVehicleUpdateCriteria] Nada Vehicle Update Criteria
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateNadaVehicleData: function (nadaVehicleUpdateCriteria, options) {
            return exports.UpdateNadaVehicleDataJDPowerApiFp(configuration).updateNadaVehicleData(nadaVehicleUpdateCriteria, options)(axios, basePath);
        },
    };
};
/**
 * UpdateNadaVehicleDataJDPowerApi - object-oriented interface
 * @export
 * @class UpdateNadaVehicleDataJDPowerApi
 * @extends {BaseAPI}
 */
var UpdateNadaVehicleDataJDPowerApi = /** @class */ (function (_super) {
    __extends(UpdateNadaVehicleDataJDPowerApi, _super);
    function UpdateNadaVehicleDataJDPowerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Update Nada Vehicle Data from JD Power
     * @param {NadaVehicleUpdateCriteria} [nadaVehicleUpdateCriteria] Nada Vehicle Update Criteria
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateNadaVehicleDataJDPowerApi
     */
    UpdateNadaVehicleDataJDPowerApi.prototype.updateNadaVehicleData = function (nadaVehicleUpdateCriteria, options) {
        return exports.UpdateNadaVehicleDataJDPowerApiFp(this.configuration).updateNadaVehicleData(nadaVehicleUpdateCriteria, options)(this.axios, this.basePath);
    };
    return UpdateNadaVehicleDataJDPowerApi;
}(base_1.BaseAPI));
exports.UpdateNadaVehicleDataJDPowerApi = UpdateNadaVehicleDataJDPowerApi;
